import React, { useEffect, useState } from 'react'
import { BiShowAlt } from 'react-icons/bi';
import { CiBitcoin, CiShare1 } from 'react-icons/ci';
import { FcNext, FcPrevious } from 'react-icons/fc';
import { FiUsers } from 'react-icons/fi';
import { IoCopy } from 'react-icons/io5';
import { MdContentCopy, MdOutlineAccountBalanceWallet } from 'react-icons/md';
import { RiLoader3Fill } from 'react-icons/ri';
import { SiBitcoinsv } from 'react-icons/si';
import { useDispatch, useSelector } from 'react-redux';
import { setClickUserId, setClickUserState, setselectedComponent } from "../Store/UserSlice";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaArrowDown, FaArrowUp, FaLocationArrow } from "react-icons/fa";
import CoinIcon from '../../asstes/Tether-USDT-icon.png'

const Forsagex3Details = () => {
    const dispatch = useDispatch();
    const HandleBack = () => { dispatch(setselectedComponent("Dashbord")); }
    const UserLevel = useSelector(state => state.user.UserLevel)
    const UserInputid = useSelector(state => state.user.UserInputid)
    const PartnerDeatils = useSelector(state => state.user.PartnerDeatils)

    const [currentLevel, setCurrentLevel] = useState(1);
    const totalLevels = 10;

    const nextLevel = () => {
        setCurrentLevel((prevLevel) => (prevLevel < totalLevels ? prevLevel + 1 : prevLevel));
    };
    const prevLevel = () => {
        setCurrentLevel((prevLevel) => (prevLevel > 1 ? prevLevel - 1 : prevLevel));
    };
    // const [showAll, setShowAll] = useState(false);
    const [data, setData] = useState([
        { type: '1', date: '2024-05-27', id: '1694000', level: '1', wallet: '0x0338E...f79BB', busd: '100' },
        { type: '3', date: '2024-05-28', id: '188160', level: '2', wallet: '0x9e969....e8da', busd: '200' },
        { type: '4', date: '2024-05-28', id: '188160', level: '5', wallet: '0x9e969....e8da', busd: '200' },
        { type: '4', date: '2024-05-28', id: '188160', level: '2', wallet: '0x9e969....e8da', busd: '200' },
        { type: '5', date: '2024-05-28', id: '188160', level: '2', wallet: '0x9e969....e8da', busd: '200' },
        { type: '6', date: '2024-05-28', id: '188160', level: '2', wallet: '0x9e969....e8da', busd: '200' },
        { type: '7', date: '2024-05-28', id: '188160', level: '2', wallet: '0x9e969....e8da', busd: '200' },
        { type: '8', date: '2024-05-28', id: '188160', level: '2', wallet: '0x9e969....e8da', busd: '200' },
        { type: '9', date: '2024-05-28', id: '188160', level: '2', wallet: '0x9e969....e8da', busd: '200' },

    ]);


    // const handleToggleShow = () => {
    //     setShowAll(!showAll);
    // };

    const [rowsToShow, setRowsToShow] = useState(3);
    const handleShowMore = () => {
        setRowsToShow(prevRowsToShow => prevRowsToShow + 3);
    };

    const handleShowLess = () => {
        setRowsToShow(prevRowsToShow => (prevRowsToShow > 3 ? prevRowsToShow - 3 : 3));
    };

    // const rowsToDisplay = showAll ? data : data?.slice(0, 3);
    // const partners = PartnerDeatils.partners.partners || 0; // Replace with actual partners data
    const partners = PartnerDeatils.partners; // Replace with actual partners data


    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        if (currentIndex < partners.length - 3) { // Adjust based on how many items you want to show at once
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prevIndex) => prevIndex - 1);
        }
    };

    const getVisiblePartners = () => {
        const start = currentIndex;
        const end = start + 3;
        const visiblePartners = partners?.slice(start, end);
        return visiblePartners;
    };

    const [TotalProfitUSDT, setTotalProfitUSDT] = useState(0);



    useEffect(() => {
        let calculatedTotalProfit = 0;
        PartnerDeatils.partners?.forEach((item) => {
          const profitUSDT = Number(item.profitAmount);
          calculatedTotalProfit += profitUSDT;
        });
        const formattedTotalProfit = calculatedTotalProfit.toString();
        // console.log("formattedTotalProfit",formattedTotalProfit)
        setTotalProfitUSDT(calculatedTotalProfit);
      }, [PartnerDeatils]);



    const PartnerDetail = PartnerDeatils.partners?.map(item => {
        const timestamp = item.time;
        const date = new Date(timestamp * 1000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;


        return {
            type: "1",
            Time: formattedDate,
            ID: item.userId,
            Level: UserLevel.Levels,
            Wallet: item.userAddress,
            Busd: item.profitAmount
        };
    });




    const CopyAddress = (address) => {
        navigator.clipboard.writeText(address)
            .then(() => {
                toast.success('Address copied to clipboard!');
            });
    };


    const handleShare = (e) => {
        window.open(`https://testnet.bscscan.com/address/${e}`, "_blank");
    };


    const ClickOnId = (id) => {
        dispatch(setClickUserState(true))
        console.log("iddddddddddd", id)
        dispatch(setClickUserId(id))
        dispatch(setselectedComponent("Dashbord"));
    }


    return (
        <>
            {/* <button onClick={GetSum}>SUMMM</button> */}
            <div className='Forsagex3Details-main-div'>
                <div className='Forsagex3Details-inner-div'>
                    <p className='Forsagex3-id-text'><span className='Forsagex3-text'>ID {UserLevel.UserId}/</span> <span className='Forsagex3-text' onClick={HandleBack}>Forsage x3 /</span>  Level</p>
                    <h1 className='level-text'>Level {UserLevel.Levels}</h1>
                </div>
                <div className="Forsagex3Details-slider-div">
                    {/* <div className="slider-btn" onClick={prevLevel}>
                        <FcPrevious /> Previous
                    </div> */}
                    <div className='Slider_top_Upline Box_Backgrounds'>
                 
                        <p>UPLINE</p>
                        <span className='Main_GradienTCoilor'>ID {PartnerDeatils.upline}</span>
                    </div>
                    <div className='box_of_slider_body'>
                    <div className="slider-body ">
                        <div className="slider-body-header">
                            <h1 className='Levels_h1'>Lvl {UserLevel.Levels}</h1>
                            <h1>ID {UserInputid}</h1>
                            <h1 className='CiBitcoin-text'>
                                {/* <SiBitcoinsv className='CiBitcoin-text-icon bg-white rounded-full'   /> */}
                                <img src={CoinIcon} className="span1-icon  bg-white rounded-full" width={"40px"}></img>
                                
                                {UserLevel.LevelAmount}</h1>
                        </div>
                        <div className='Crowsal_Partner'>

                            {partners?.length > 3 && <FcPrevious size={60} disabled={currentIndex === 0} onClick={prevSlide}
                                color='green'
                                opacity={currentIndex === 0 ? "0" : ''}
                            />}
                            <div className="slider-body-cyrcle">

                                {getVisiblePartners()?.map((partner, index) => (
                                    <div key={index} className="cyrcle-one">
                                        {partner.userId}
                                    </div>
                                ))}
                            </div>
                            {partners?.length > 3 && <FcNext onClick={nextSlide}
                                disabled={currentIndex >= partners.length - 3}
                                size={60}
                                opacity={currentIndex >= partners.length - 3 ? "0" : ''}
                            />}
                        </div>
                        <div className="slider-footer">

                            <div className="slider-footer-Partners-div">
                                <p>Partners</p>
                                <p className='slider-footer-heading'>
                                    <> <FiUsers /> </>
                                    <span>{partners?.length}</span></p>
                            </div>
                            {/* <div className="slider-footer-Cycles-div">
                                <h1>Cycles</h1>
                                <h1 className='slider-footer-heading'><RiLoader3Fill />8870</h1>
                            </div> */}
                            <div className="slider-footer-Total-level-div">
                                <h1>Total level revenue</h1>
                                <h1 className='slider-footer-heading'><MdOutlineAccountBalanceWallet />{TotalProfitUSDT} BUSD</h1>
                            </div>
                        </div>
                    </div>
                    </div>
                    {/* <div className="slider-btn" onClick={nextLevel}>
                        Next<FcNext />
                    </div> */}
                </div>
                {/* {/ slider div end /} */}
                <div className="Forsagex3Details-data-table-div Box_Backgrounds">

                    <table className="Forsagex3Details-data-table text-white">
                        <thead >
                            <tr>
                                <td className='Table_Borders_all'>Type</td>
                                <td className='Table_Borders_all'>Date</td>
                                <td className='Table_Borders_all'>Level</td>
                                <td className='Table_Borders_all' >Wallet</td>
                                <td className='Table_Borders_all '>ID</td>
                                <td className='Table_Borders_all'>BUSD</td>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {rowsToDisplay.map((item, index) => ( */}
                            {
                                PartnerDetail?.slice(0, rowsToShow).map((item, index) => (
                                    <tr key={index} className="table-row text-white">
                                        <td>{index + 1}</td>
                                        <td>{item.Time}</td>
                                        
                                        <td>{item.Level}</td>
                                        <td className="wallet-row">
                                            {`${item.Wallet?.slice(0, 6) + "..." + item.Wallet?.slice(-5)}`}
                                            <MdContentCopy size={20} onClick={() => CopyAddress(item.Wallet)} className='Copy_btn_Class' />
                                            <FaLocationArrow onClick={() => handleShare(item.Wallet)} className='opacity-55 FaLocationArrow' />
                                        </td>
                                        <td className="  text-white" onClick={() => ClickOnId(item.ID)}><span className='id-row id-td-row  td_row1 Main_GradienTCoilor'>ID {item.ID}</span></td>
                                        <td>{item.Busd}</td>
                                    </tr>
                                ))
                            }
                            {/* ))} */}
                        </tbody>
                    </table>
                    {
                        PartnerDetail?.length > 1 ?
                            <div className="show-table " >
                                <p onClick={handleShowLess} className='Main_GradienTCoilor'><FaArrowUp /> <span>Show Less</span></p>
                                <p onClick={handleShowMore} className='Main_GradienTCoilor'><FaArrowDown /> <span>Show more</span></p>
                            </div>
                            :
                            <p className='Dat_Not_found'>No Data Found</p>
                    }
                </div>
            </div>

            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                // pauseOnHover
                theme="light"
            />
        </>
    )
}



export default Forsagex3Details